// Global Instructions Rule Applied!
import React, { useState } from 'react'
import { Button as AntButton, Dropdown, Popconfirm } from 'antd'
import Button from './Button.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV, faTrash } from '@fortawesome/free-solid-svg-icons'

const DRAWER_TRIGGER_CLASS =
  'bg-white/20 border-white/40 text-white px-3 py-1 h-auto hover:!bg-white/30 hover:!border-white/60 hover:!text-white'

export function RecordFormDeleteEllipses({
  confirmTitle,
  confirmDescription,
  onDelete,
  disabled = false,
  loading = false,
  variant = 'default'
}: {
  confirmTitle: string
  confirmDescription?: string
  onDelete: () => Promise<void>
  disabled?: boolean
  loading?: boolean
  variant?: 'default' | 'drawer'
}) {
  const [popOpen, setPopOpen] = useState(false)

  const trigger =
    variant === 'drawer' ? (
      <AntButton
        data-debug='drawer-delete-ellipses-btn'
        size='small'
        icon={<FontAwesomeIcon icon={faEllipsisV} />}
        className={DRAWER_TRIGGER_CLASS}
        style={{ width: '32px', height: '32px', padding: 0, minWidth: 0 }}
        loading={loading}
        disabled={disabled}
      />
    ) : (
      <Button
        variant='default'
        data-debug='record-delete-ellipses-btn'
        size='small'
        icon={<FontAwesomeIcon icon={faEllipsisV} style={{ color: '#9ca3af' }} />}
        loading={loading}
        disabled={disabled}
        style={{ width: '32px', height: '32px', padding: 0, minWidth: 0 }}
      />
    )

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'delete',
            label: (
              <span>
                <FontAwesomeIcon icon={faTrash} style={{ marginRight: 8, color: 'currentColor' }} />
                Delete
              </span>
            ),
            danger: true,
            onClick: () => setPopOpen(true)
          }
        ]
      }}
      trigger={['click']}
    >
      <Popconfirm
        title={confirmTitle}
        {...(confirmDescription
          ? {
              description: (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '300px' }}>
                  {confirmDescription}
                </div>
              )
            }
          : {})}
        onConfirm={async () => {
          setPopOpen(false)
          await onDelete()
        }}
        onCancel={() => setPopOpen(false)}
        okText='Delete'
        cancelText='Cancel'
        okButtonProps={{ danger: true, loading }}
        cancelButtonProps={{ disabled: loading }}
        open={popOpen}
        getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
      >
        {trigger}
      </Popconfirm>
    </Dropdown>
  )
}
